module.exports = __webpack_public_path__ + "static/media/project-blog.9a91c0e7.png";